<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
import { Websocket } from '@/assets/websocket/Websocket.js'
export default {
  mixins: [Websocket],
    created() {
        let script = document.createElement("script");
        script.type = "text/javascript";
        script.src = "http://api.map.baidu.com/api?v=2.0&ak=fATk345GNpp3ZUuZMI0z81ZPjlM132eR";

        let script1 = document.createElement("script");
        script1.type = "text/javascript";
        script1.src = "https://api.map.baidu.com/getscript?type=webgl&v=1.0&ak=fATk345GNpp3ZUuZMI0z81ZPjlM132eR&services=&t=20241025145639";
    },
    methods: {
    SUCCESSFULLY_CONNECTED(msg) {
      console.log('SUCCESSFULLY_CONNECTED', msg)
    },
    HEARTBEAT(msg) {
      console.log('HEARTBEAT', msg)
    },
    SUPPLIER_ORDER_LIST(data) {
      console.log('SUPPLIER_ORDER_LIST', data)
    },
  },
}
</script>
<style>
@import url('./assets/css/base.css');
@import url('./assets/css/color.css');
@import url('./assets/css/button.css');
</style>
